import { Box, makeStyles, Theme } from '@material-ui/core'
import { FormattedDate, FormattedMessage } from 'react-intl'
import MDTooltip, { MDTooltipVariants } from './MDTooltip'
import { Linq } from '@src/components/Linq'
import MultiMessageIcon from '@src/icons/MultiMessageIcon'

const useStyles = makeStyles((theme: Theme) => ({
  commentTitle: {
    display: 'flex',
    gap: theme.spacing(2),
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightMedium,
  },
  container: {
    marginTop: theme.spacing(1),
  },
  commentTimestamp: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.grey[700],
  },
  commentMessage: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightRegular,
  },
  commentHelperMessage: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightRegular,
  },
  multiMessageIcon: {
    width: '32px',
    height: '32px',
  },
  separator: {
    color: theme.palette.grey[500],
  },
}))

const MDCommentsCol = ({ item }) => {
  const classes = useStyles()

  const { timestamp, message } = item?.comments?.[0] || {}

  return (
    <>
      <MDTooltip
        variant={MDTooltipVariants.comments}
        count={item.comments.length}
        title={<FormattedMessage id="COMMENTS" defaultMessage="Comments" />}
      >
        <>
          <MultiMessageIcon
            height={32}
            width={32}
            className={classes.multiMessageIcon}
          />
          <Box className={classes.container}>
            <Box className={classes.commentTitle}>
              <FormattedMessage
                id="CUSTOMER_SUPPORT"
                defaultMessage="Customer Support"
              />
              <span className={classes.separator}>|</span>
              <span className={classes.commentTimestamp}>
                <FormattedDate
                  value={timestamp}
                  month="short"
                  year="numeric"
                  day="numeric"
                />
              </span>
            </Box>
            <Box className={classes.commentMessage}>{message}</Box>
            <Box className={classes.commentHelperMessage}>
              <FormattedMessage
                id="FOR_MORE_INFORMATION_VISIT_ORDER_DETAILS_PAGE"
                defaultMessage="For more information, visit: {link}"
                values={{
                  link: (
                    <Linq href={'#'}>
                      <FormattedMessage
                        id="ORDER_DETAILS_PAGE"
                        defaultMessage="Order Details Page"
                      />
                    </Linq>
                  ),
                }}
              ></FormattedMessage>
            </Box>
          </Box>
        </>
      </MDTooltip>
    </>
  )
}

export default MDCommentsCol
